import {BackendResponse} from "../../@core/@bus/request.model";
import {GenericRequest, GenericResponse} from "../../models/generic";
import {Backend} from "../../core/backend";
import {LoginRequest, LoginResponse} from "../../models/login";
import {Authentication} from "../../core/authentication";
import {GetGlobalEventManager} from "../../core/bus-configuration";
import {BusService} from "../../@core/@bus/bus.service";

export type SocioDataT = {
  nif: string;
  email: string;
  nombre: string;
  apellido: string;
  telefono: string;
  expediente: string;
  apellido2: string;
  password?: string;
  portal?: true;
}

export default class SsoService {
  static PORTAL_MAPFRE: string = 'mapfre';
  static PORTAL_SABADELL: string = 'sabadell';
  private static PORTALES = [ SsoService.PORTAL_MAPFRE, SsoService.PORTAL_SABADELL ];

  data: string = '';
  portal: string = '';
  command: string = '';

  constructor(portal: string, data: string, private bus: BusService) {
    if (!SsoService.PORTALES.includes(portal)) {
      this.bus.dom.toastError('SSO: Error en la inicializacion');
    }

    this.portal = portal;
    this.data = data;
  }

  consultaSocio(): Promise<SocioDataT> {
    const requestConsulta: GenericRequest = new GenericRequest();
    requestConsulta.command = "consulta_socio_" + this.portal;
    requestConsulta.data = this.data;

    return new Promise<SocioDataT>((resolve, reject): void => {
      Backend.generic(requestConsulta).then(async (responseConsulta: BackendResponse): Promise<void> => {
        if (responseConsulta.error) {
          reject(responseConsulta.error);
          return;
        }

        if (!responseConsulta.data) {
          reject("Datos del socio no encontrados.");
          return;
        }

        const socioData: any = JSON.parse(responseConsulta.data) as SocioDataT;
        resolve(socioData);
      }).catch((error: any): void => {
        reject('Error al consultar socio' + this.portal + ': ' + error);
        return;
      });
    });
  }

  updateContactoExpediente(): Promise<boolean> {
    const requestConsulta: GenericRequest = new GenericRequest();
    requestConsulta.command = "update_contacto_expediente_" + this.portal;
    requestConsulta.data = this.data;

    return new Promise<boolean>((resolve, reject): void => {
      Backend.generic(requestConsulta).then(async (responseConsulta: BackendResponse): Promise<void> => {
        if (responseConsulta.error) {
          reject(responseConsulta.error);
          return;
        }

        // Devuelve el id del expediente si ha ido bien
        resolve(responseConsulta.data > '0');
      }).catch((error: any): void => {
        reject('Error al actualizar el expediente: ' + error);
        return;
      });
    });
  }

  signIn(): Promise<void> {
    return new Promise((_, reject) => {
      const requestSSO: GenericRequest = new GenericRequest();
      requestSSO.command = 'sso_' + this.portal;
      requestSSO.data = this.data;

      Backend.generic(requestSSO).then((responseSSO: BackendResponse): void => {
        if (responseSSO.error) {
          reject(responseSSO.error);
          return;
        }

        const loginRequest: LoginRequest = new LoginRequest();
        loginRequest.login = this.data;
        if (this.portal === 'sabadell') {
          loginRequest.sso = responseSSO.data;
        } else {
          loginRequest.password = this.data;
        }

        Authentication.login(loginRequest).then((logged: LoginResponse): void => {
          if (logged.logged) {
            const routed: boolean = GetGlobalEventManager().routeIfPendingConfigurations();
            if (!routed) {
              const requestUpdate: GenericRequest = new GenericRequest();
              requestUpdate.command = "force_update";

              Backend.genericAuth(requestUpdate).then((responseUpdate: GenericResponse): void => {
                if (responseUpdate.error === "") {
                  Authentication.goToLanding().then((): void => {});
                } else {
                  reject(responseUpdate.error);
                  return;
                }
              });
            } else {
              this.bus.router.goTo("/configuracion").then((): void => {});
            }
            return;
          }
        }).catch((error: any): void => {
          reject('Error al iniciar sesión: ' + error);
          this.unauthorized();
          return;
        });
      }).catch((error: any): void => {
        reject('Error al realizar el login SSO: ' + error);
        this.unauthorized();
        return;
      });
    });
  }

  loginSSOMapfreWithoutExp(): Promise<void> {
    const requestConsulta: GenericRequest = new GenericRequest();
    requestConsulta.command = "consulta_socio_exentalia_mapfre";
    requestConsulta.data = this.data;

    return new Promise<void>((_, reject): void => {
      Backend.generic(requestConsulta).then(async (responseConsulta: BackendResponse): Promise<void> => {
        if (responseConsulta.error) {
          reject(responseConsulta.error);
          return;
        }

        const socioData: any = responseConsulta.data;
        if (!socioData) {
          reject('Datos del socio no encontrados.');
          return;
        }

        // Sign In
        await this.signIn();
      }).catch((error: any): void => {
        console.error('Error al consultar socio Mapfre' + error);
        this.unauthorized();
        return;
      });
    });
  }

  datosSocioCompletos(data: SocioDataT): boolean {
    return data.portal === true && data.email.length > 0 && data.telefono.length > 0 && data.nombre.length > 0 && data.apellido.length > 0;
  }

  loginSSOMapfreWithoutExpPrueba(): Promise<void> {
    const requestConsulta: GenericRequest = new GenericRequest();

    let email = localStorage.getItem('email');
    let telefono = localStorage.getItem('telefono');
    let nombre = localStorage.getItem('nombre');
    let apellido1 = localStorage.getItem('apellido1');
    let apellido2 = localStorage.getItem('apellido2');
    if (!email) {
      email = 'jose.villatoro@vozitel.com';
      localStorage.setItem('email', email)
    }
    if (!telefono) {
      telefono = '616616616';
      localStorage.setItem('email', telefono)
    }
    if (!nombre) {
      nombre = 'Pruebas';
      localStorage.setItem('nombre', nombre)
    }
    if (!apellido1) {
      apellido1 = 'Mapfre';
      localStorage.setItem('apellido1', apellido1)
    }
    if (!apellido2) {
      apellido2 = 'SSO';
      localStorage.setItem('email', apellido2)
    }

    const data = {
      'nif': this.data,
      'email': email,
      'telefono': telefono,
      'nombre': nombre,
      'apellido1': apellido1,
      'apellido2': apellido2
    };

    requestConsulta.command = "consulta_socio_exentalia_mapfre_pruebas";
    requestConsulta.data = JSON.stringify(data);

    return new Promise<void>((_, reject): void => {
      Backend.generic(requestConsulta).then(async (responseConsulta: BackendResponse): Promise<void> => {
        if (responseConsulta.error) {
          reject(responseConsulta.error);
          return;
        }

        const socioData: any = responseConsulta.data;
        if (!socioData) {
          reject("Datos del socio no encontrados.");
          return;
        }

        // Sign In
        await this.signIn();
      }).catch((error: any): void => {
        reject('Error al consultar socio Mapfre: ' + error);
        return;
      });
    });
  }

  async goToNuevoUsuario(socioData: SocioDataT): Promise<void> {
    const request: GenericRequest = new GenericRequest();
    request.command = 'bs_sso_generate_user_token';
    request.data = JSON.stringify(socioData);

    return new Promise<void>((_, reject): void => {
      Backend.generic(request).then((response: GenericResponse): void => {
        if (response.error) {
          reject('Ha ocurrido un error: ' + response.error);
          return;
        }

        this.bus.router.goTo('/nuevo-usuario?token=' + response.data);
      });
    }).catch((_) => {
      this.unauthorized();
    });
  }

  async getNifFromToken(token: string): Promise<SocioDataT|null> {
    const request: GenericRequest = new GenericRequest();
    request.command = 'bs_sso_validate_user_token';
    request.data = token;

    return new Promise<SocioDataT|null>((resolve, reject): void => {
      Backend.generic(request).then((response: GenericResponse): void => {
        if (response.error) {
          reject('Ha ocurrido un error: ' + response.error);
          return;
        }

        resolve(JSON.parse(response.data) as SocioDataT);
      });
    }).catch((_) => {
      this.unauthorized();
      return null;
    });
  }

  unauthorized(): void {
    Authentication.logout(false);
    this.bus.router.goTo('/unauthorized');
  }
}
